import {animateByClass} from '../Library/Animation';

export const popTagColorSwatch = (target) => {
    if (!target || typeof target.matches !== 'function') {
        return;
    }

    if (!target.matches('.tag-color-swatch input[type=radio]')) {
        return;
    }

    animateByClass(target.closest('.tag-color-swatch'), 'pop');
};

export const refreshTagPreview = (target) => {
    if (!target || typeof target.matches !== 'function') {
        return;
    }

    if (!target.matches('input[name="name"], input[name="color"]')) {
        return;
    }

    const form = target.closest('form');

    if (form === null) {
        return;
    }

    const preview = form.querySelector('[data-tag-preview]');

    if (preview === null) {
        return;
    }

    const nameInput  = form.querySelector('input[name="name"]');
    const colorInput = form.querySelector('input[name="color"]:checked');

    if (nameInput !== null) {
        preview.textContent = nameInput.value || preview.dataset.tagPreviewPlaceholder || '';
    }

    if (colorInput !== null) {
        [...preview.classList]
            .filter((className) => className.startsWith('store-tag--'))
            .forEach((className) => preview.classList.remove(className));

        preview.classList.add('store-tag--' + colorInput.value);
    }
};
